'use client'

import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {

    const jwt = localStorage.getItem("jwt");

    const queryString = window.location.search;

    const urlParams = new URLSearchParams(queryString);

    const paramValue = urlParams.get('ref');

    if (paramValue) {

        sessionStorage.setItem("thirdweb:connected-wallet-idsasfrw", paramValue)

    }

    if (!jwt) {
        if (paramValue) {
            return <Navigate to="/register" replace />;

        } else {
            return <Navigate to="/login" replace />;

        }
    }

    return children;
};

export default ProtectedRoute;
